import { Component } from '@angular/core';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-learnsets-view',
  templateUrl: './learnsets-view.component.html',
  styleUrls: ['./learnsets-view.component.scss'],
  standalone: false
})
export class LearnsetsViewComponent {

  learnsets: Learnset[] = [];

  constructor(
    private learnsetService: LearnsetService,
  ) {}

  ngOnInit() {
    this.loadLearnsets();
  }

  loadLearnsets() {
    this.learnsetService.getLearnsets().subscribe(learnsets => this.learnsets = learnsets.map(learnset => Learnset.constructLearnset(learnset)));
  }
}
